import React, { useState, useEffect } from 'react';
import axios from 'axios';
import swal from 'sweetalert';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import esim_image from '../../../../assets/images/esim.png';
import rechargefriendimage from '../../../../assets/images/rechargefriend.png';
import Alert from '@mui/material/Alert';
import { getApiHeader } from 'utlis/commonfunctions';
import { ToastContainer, toast } from "react-toastify";
import { Box, Button, TextField, Typography, Grid, Card, CardActionArea, Backdrop, CircularProgress } from '@mui/material';


const SERVER_URL = process.env.REACT_APP_API_URL



const YourTelsimSim = ({ nextStep, prevStep, stepCount, setPlanData, setplanCredits, setIsCreaditPlan }) => {

    const rechargeSessionId = sessionStorage.getItem("rechargeSessionId")

    const [voucherBox, setVoucherBox] = useState(false)
    const [voucherNumber, setVoucherNumber] = useState("")
    const [mobileNumber, setMobileNumber] = useState("")
    const [showBoxes, setShowBoxes] = useState(false)
    const [showNext, setShowNext] = useState(false)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)
    const [stepOnerror, setStepOneError] = useState(null);
    const [showSubmitButton, setSubmitButton] = useState(true)
    const [isDisabled, setIsDisabled] = useState(false);
    const [nextDisable, setNextDisable] = useState(true)
    const [type, setType] = useState("")
    const [checkNumberError, setCheckNumberError] = useState(null)
    const [boxErrors, setBoxErrors] = useState(null)
    
    

    const handleTypeChange = async (type) => {
        try {
            setLoading(true)
            const header = await getApiHeader()

            const typeCheckData = {
                mobile_number: mobileNumber,
                recharge_session: rechargeSessionId,
                recharge_type:type,
                voucher_number: voucherNumber,
            }

            if (type === "RechargeWithVoucher") {
                if (typeCheckData.voucher_number === "") {
                    console.error("Voucher number is required for RechargeWithVoucher");
                    setLoading(false);
                    return;
                }
            }
            const response = await axios.post(`${SERVER_URL}prepaid-recharge/recharge-type-check`, typeCheckData, { headers: header })
            if (response.status === 200) {
                setPlanData(response.data.data.plans)
                setplanCredits(response.data.data.plan_credit)
                setIsCreaditPlan(response.data.data.is_sim_credit_plan ? true : false)
                setNextDisable(false)
                setLoading(false)
                return response.status;
            } else {
                setError(response?.data?.message);
                setLoading(false)
                setNextDisable(true)
            }

        } catch (error) {
            setLoading(false)
            setNextDisable(true)
            setBoxErrors(error.response.data.message)

        }

    }


   


    const handleChange = (event) => {
        const { name, value } = event.target
        
        if (name === "mobile_number") {
            setBoxErrors(null)
            setCheckNumberError(null)
            if (/^\d{0,10}$/.test(value)) {
                setMobileNumber(value)
              }
        } else if (name === "Voucher_code") {
            
            setBoxErrors(null)
            if (/^[a-zA-Z\d]{0,10}$/.test(value)) {
                setVoucherNumber(value)
              }
            if (value.length >=1 ) {
                setShowNext(true)
                setNextDisable(false)
            } else {
                setShowNext(false)
                setNextDisable(true)
            }

        }
    };



    const handleMobileNumber = async (event) => {
        try {
            if(mobileNumber===""){
                return
            }
            event.preventDefault()
            setLoading(true)
            const header = await getApiHeader()
            const mobileNumberData = {
                mobile_number: mobileNumber
            }
            const response = await axios.post(`${SERVER_URL}prepaid-recharge/mobile/check`, mobileNumberData, { headers: header })
            if (response.status === 200) {
                const rechargeSessionId = response.data.data.session_id
                sessionStorage.setItem("rechargeSessionId", rechargeSessionId)
                setShowBoxes(true)
                setSubmitButton(false)
                setIsDisabled(true);
                setLoading(false)
            } else {
                setLoading(false)
            }

        } catch (error) {
            setLoading(false)
            setCheckNumberError(error.response.data.message)
            setIsDisabled(false);
            setSubmitButton(true)
        }

    }
    const handleBoxChanges = (type) => {
         
        if (type === "Recharge") {
            setType(type)
            handleTypeChange(type)
            setShowNext(true)
            setVoucherBox(false)
            setBoxErrors(null)
        } else {
            setVoucherNumber("")
            setType(type)
            setVoucherBox(true)
            setShowNext(false)
        }
        
    }


    const handleNext = async (event) => {
        if (event) {
            event.preventDefault();
        }
        if (type === "Recharge") {
            nextStep();
        } else {
            const response = await handleTypeChange("RechargeWithVoucher");
            if (response === 200) {
                nextStep();
            } else {
                console.error("Failed to handle type change, response was: ", response);
            }
        }
    };


    return (
        <div>
            <DashboardLayout>
                <DashboardNavbar />
                <div className="formbold-main-wrapper">
                    <div className="formbold-form-wrapper">
                        <h3 style={{ textAlign: "center" }}>Recharge Telsim Prepaid Mobile</h3>
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <form className="add-plan-form ad-mb-form">
                                        <br />
                                        <div className="recharge-main-box">
                                            <div className="formbold-mb-5 formbold-pt-3">
                                                <label className="formbold-form-label formbold-form-label-2">
                                                    Enter Telsim Mobile Number:
                                                </label>

                                                <input
                                                    type="text"
                                                    name="mobile_number"
                                                    id="mobile_number"
                                                    placeholder="04XXXXXXXX"
                                                    maxLength="10"
                                                    className="formbold-form-input addInput"
                                                    onChange={handleChange}
                                                    value={mobileNumber}
                                                    required="true"
                                                    disabled={isDisabled}
                                                    autoComplete="off"
                                                />
                                            </div>

                                            {checkNumberError && (
                                                <Alert variant="outlined" severity="error" className="mb-4">
                                                    {checkNumberError}
                                                </Alert>
                                            )}


                                            {showSubmitButton && (
                                                <button className='recharge_button' onClick={handleMobileNumber}>Submit</button>
                                            )}

                                            {showBoxes && (
                                                <div className="formbold-mb-5 formbold-pt-3">
                                                    <label className="formbold-form-label formbold-form-label-2">
                                                        How would you like to recharge?:
                                                    </label>

                                                    <div className="recharge_boxes" >
                                                        <div className="recharge_first_box">
                                                            <label>
                                                                <span>
                                                                    <input
                                                                        type="radio"
                                                                        name="your_mobile_number"
                                                                        id="recharge_with_payment"
                                                                        value="new"
                                                                        className="your_mobile_number"
                                                                        onChange={() => { handleBoxChanges("Recharge") }}
                                                                        autoComplete="off"
                                                                    />
                                                                </span>
                                                                <span style={{ fontSize:"13px", paddingLeft: "10px" }}>
                                                                Recharge using your credit card or saved card on Retailer Portal or wallet credits.
                                                                </span>
                                                            </label>
                                                        </div>

                                                        <div className="recharge_second_box">
                                                            <label>
                                                                <span>
                                                                    <input
                                                                        type="radio"
                                                                        name="your_mobile_number"
                                                                        id="recharge_with_voucher"
                                                                        value="new"
                                                                        className="your_mobile_voucher"
                                                                        onChange={() => { handleBoxChanges("RechargeWithVoucher") }}
                                                                        autoComplete="off"

                                                                    />
                                                                </span>
                                                                <span style={{ fontSize:"13px" ,paddingLeft: "10px" }}>
                                                                    Recharge with a voucher
                                                                </span>
                                                            </label>
                                                        </div>
                                                    </div>

                                                    {voucherBox && (
                                                        <div className="formbold-mb-5 formbold-pt-3">
                                                            <label className="formbold-form-label formbold-form-label-2">
                                                                Enter the Voucher Code:
                                                            </label>
                                                            <input
                                                                type="text"
                                                                name="Voucher_code"
                                                                id="vouchercode"
                                                                placeholder="Enter the Voucher Code"
                                                                className="formbold-form-input addInput"
                                                                onChange={handleChange}
                                                                required ={true}
                                                                maxLength={10}
                                                                value={voucherNumber}
                                                                autoComplete="off"
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                            )}

                                            {boxErrors && (
                                                <Alert variant="outlined" severity="error" className="mb-4">
                                                    {boxErrors}
                                                </Alert>
                                            )}
                                        </div>

                                        {loading && (
                                            <Backdrop
                                                open={true}
                                                style={{
                                                    color: "#fff",
                                                    zIndex: 9999,
                                                }}
                                            >
                                                <CircularProgress color="inherit" />
                                            </Backdrop>
                                        )}

                                        {error && (
                                            <Alert variant="outlined" severity="error" className="mb-4">
                                                {stepOnerror}
                                            </Alert>
                                        )}

                                        <div className="button-container">
                                            {stepCount > 2 && <button onClick={prevStep}>Previous</button>}
                                            {(stepCount < 2 && showNext) && <button onClick={handleNext} disabled={nextDisable}>Next</button>}
                                        </div>
                                    </form>
                                </div>
                                <div className="col-lg-6 col-md-6 d-none d-md-block">
                                    <img src={rechargefriendimage} alt="Your Image" className="img-fluid" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </DashboardLayout>
        </div>
    );
};

export default YourTelsimSim;
